// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/opportunity_signal.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.datagateway.v1.AwardCompletionSelection
 */ export class AwardCompletionSelection extends Message {
    static fromBinary(bytes, options) {
        return new AwardCompletionSelection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardCompletionSelection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardCompletionSelection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardCompletionSelection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string scope = 1;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string period = 2;
   */ _define_property(this, "period", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardCompletionSelection, "runtime", proto3);
_define_property(AwardCompletionSelection, "typeName", "mono.datagateway.v1.AwardCompletionSelection");
_define_property(AwardCompletionSelection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OpenAwardFollowOnRequest
 */ export class OpenAwardFollowOnRequest extends Message {
    static fromBinary(bytes, options) {
        return new OpenAwardFollowOnRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenAwardFollowOnRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenAwardFollowOnRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenAwardFollowOnRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_id = 1;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string opening_request_id = 2;
   */ _define_property(this, "openingRequestId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: mono.datagateway.v1.AwardCompletionSelection current = 4;
   */ _define_property(this, "current", void 0), /**
   * @generated from field: mono.datagateway.v1.AwardCompletionSelection ultimate = 5;
   */ _define_property(this, "ultimate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenAwardFollowOnRequest, "runtime", proto3);
_define_property(OpenAwardFollowOnRequest, "typeName", "mono.datagateway.v1.OpenAwardFollowOnRequest");
_define_property(OpenAwardFollowOnRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opening_request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "current",
            kind: "message",
            T: AwardCompletionSelection
        },
        {
            no: 5,
            name: "ultimate",
            kind: "message",
            T: AwardCompletionSelection
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetAwardSignalRequest
 */ export class GetAwardSignalRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAwardSignalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAwardSignalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAwardSignalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAwardSignalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAwardSignalRequest, "runtime", proto3);
_define_property(GetAwardSignalRequest, "typeName", "mono.datagateway.v1.GetAwardSignalRequest");
_define_property(GetAwardSignalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateAwardSignalHypothesisRequest
 */ export class UpdateAwardSignalHypothesisRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAwardSignalHypothesisRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAwardSignalHypothesisRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAwardSignalHypothesisRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAwardSignalHypothesisRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * Empty clears; otherwise YYYY-MM-DD.
   *
   * @generated from field: string date = 2;
   */ _define_property(this, "date", ""), /**
   * @generated from field: string note = 3;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAwardSignalHypothesisRequest, "runtime", proto3);
_define_property(UpdateAwardSignalHypothesisRequest, "typeName", "mono.datagateway.v1.UpdateAwardSignalHypothesisRequest");
_define_property(UpdateAwardSignalHypothesisRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AwardSignalSource
 */ export class AwardSignalSource extends Message {
    static fromBinary(bytes, options) {
        return new AwardSignalSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardSignalSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardSignalSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardSignalSource, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string evidence_id = 1;
   */ _define_property(this, "evidenceId", ""), /**
   * @generated from field: string observation_id = 2;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: string source = 3;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_version = 4;
   */ _define_property(this, "sourceVersion", ""), /**
   * @generated from field: string source_location = 5;
   */ _define_property(this, "sourceLocation", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_at = 6;
   */ _define_property(this, "effectiveAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 7;
   */ _define_property(this, "retrievedAt", void 0), /**
   * @generated from field: string value_state = 8;
   */ _define_property(this, "valueState", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardSignalSource, "runtime", proto3);
_define_property(AwardSignalSource, "typeName", "mono.datagateway.v1.AwardSignalSource");
_define_property(AwardSignalSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_location",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "effective_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "value_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AwardSignal
 */ export class AwardSignal extends Message {
    static fromBinary(bytes, options) {
        return new AwardSignal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardSignal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardSignal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardSignal, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string contract_id = 3;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string contract_identity = 4;
   */ _define_property(this, "contractIdentity", ""), /**
   * @generated from field: string parent_contract_id = 5;
   */ _define_property(this, "parentContractId", ""), /**
   * @generated from field: string parent_identity = 6;
   */ _define_property(this, "parentIdentity", ""), /**
   * @generated from field: optional string incumbent_company_id = 7;
   */ _define_property(this, "incumbentCompanyId", void 0), /**
   * @generated from field: string incumbent_name = 8;
   */ _define_property(this, "incumbentName", ""), /**
   * @generated from field: optional string observed_current_completion = 9;
   */ _define_property(this, "observedCurrentCompletion", void 0), /**
   * @generated from field: optional string observed_ultimate_completion = 10;
   */ _define_property(this, "observedUltimateCompletion", void 0), /**
   * @generated from field: optional string potential_recompete_horizon = 11;
   */ _define_property(this, "potentialRecompeteHorizon", void 0), /**
   * @generated from field: string horizon_basis = 12;
   */ _define_property(this, "horizonBasis", ""), /**
   * @generated from field: optional string team_timing_hypothesis = 13;
   */ _define_property(this, "teamTimingHypothesis", void 0), /**
   * @generated from field: string hypothesis_note = 14;
   */ _define_property(this, "hypothesisNote", ""), /**
   * @generated from field: string coverage = 15;
   */ _define_property(this, "coverage", ""), /**
   * @generated from field: mono.datagateway.v1.AwardSignalSource current_source = 16;
   */ _define_property(this, "currentSource", void 0), /**
   * @generated from field: mono.datagateway.v1.AwardSignalSource ultimate_source = 17;
   */ _define_property(this, "ultimateSource", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardSignal, "runtime", proto3);
_define_property(AwardSignal, "typeName", "mono.datagateway.v1.AwardSignal");
_define_property(AwardSignal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_identity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "parent_contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "parent_identity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "incumbent_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 8,
            name: "incumbent_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "observed_current_completion",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 10,
            name: "observed_ultimate_completion",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 11,
            name: "potential_recompete_horizon",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 12,
            name: "horizon_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "team_timing_hypothesis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 14,
            name: "hypothesis_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "coverage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "current_source",
            kind: "message",
            T: AwardSignalSource
        },
        {
            no: 17,
            name: "ultimate_source",
            kind: "message",
            T: AwardSignalSource
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OpenAwardFollowOnResponse
 */ export class OpenAwardFollowOnResponse extends Message {
    static fromBinary(bytes, options) {
        return new OpenAwardFollowOnResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenAwardFollowOnResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenAwardFollowOnResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenAwardFollowOnResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AwardSignal signal = 1;
   */ _define_property(this, "signal", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenAwardFollowOnResponse, "runtime", proto3);
_define_property(OpenAwardFollowOnResponse, "typeName", "mono.datagateway.v1.OpenAwardFollowOnResponse");
_define_property(OpenAwardFollowOnResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "signal",
            kind: "message",
            T: AwardSignal
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetAwardSignalResponse
 */ export class GetAwardSignalResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAwardSignalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAwardSignalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAwardSignalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAwardSignalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AwardSignal signal = 1;
   */ _define_property(this, "signal", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAwardSignalResponse, "runtime", proto3);
_define_property(GetAwardSignalResponse, "typeName", "mono.datagateway.v1.GetAwardSignalResponse");
_define_property(GetAwardSignalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "signal",
            kind: "message",
            T: AwardSignal
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateAwardSignalHypothesisResponse
 */ export class UpdateAwardSignalHypothesisResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAwardSignalHypothesisResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAwardSignalHypothesisResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAwardSignalHypothesisResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAwardSignalHypothesisResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AwardSignal signal = 1;
   */ _define_property(this, "signal", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAwardSignalHypothesisResponse, "runtime", proto3);
_define_property(UpdateAwardSignalHypothesisResponse, "typeName", "mono.datagateway.v1.UpdateAwardSignalHypothesisResponse");
_define_property(UpdateAwardSignalHypothesisResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "signal",
            kind: "message",
            T: AwardSignal
        }
    ]));
